import { useEffect, useState } from 'react';
import { Predicate } from '../../../models/predicate.model';
import { useDespesaService } from '../../../services/despesa.service';

export const useFetchBignumbersData = () => {
	const [total, setTotal] = useState<number>(0.0);
	const [pago, setPago] = useState<number>(0.0);
	const [aVencer, setAVencer] = useState<number>(0.0);
	const [vencida, setVencida] = useState<number>(0.0);
	const [hoje, setHoje] = useState<number>(0.0);
	const despesaService = useDespesaService();

	const fetchBignumbers = async (predicate: Predicate) => {
		const bignumbersRes = await despesaService.getBignumbers(predicate);

		const { data: big } = bignumbersRes;

		setHoje(big.vlVenceHoje);
		setTotal(big.vlTotal);
		setPago(big.vlVencidosPagos);
		setAVencer(big.vlVencendo);
		setVencida(big.vlVencidos);
	};

	return {
		total,
		pago,
		aVencer,
		vencida,
		hoje,
		fetchBignumbers,
	};
};
